module.exports = __webpack_public_path__ + "static/media/heart.d4d554e4.svg";